import Api from '@api/xiu_yan/marketingToolsApi'
import mainStore from '@components/Main/store'
import { BOND_PATH_A, SHOP_PRODUCTS_PATH_A } from '@constant'
import { isProfessional, isUltimate } from '@merchant-backend/util'
import { getProTitle } from '@util'
import { action, observable, runInAction } from 'mobx'
import consultStore from '../ConsultGift/store'
import setConsultGiftStore from '../SetConsultGift/store'

class Store {
  @observable key = '1'

  @observable gift_status
  @observable promise_status
  @observable back_status

  @action
  getTabInfo = async () => {
    let { data } = await Api.record_list()
    runInAction(() => {
      this.gift_status = data[0].status
      this.promise_status = data[1].status
      this.back_status = data[2].status
      consultStore.gift_status = data[6].status
      setConsultGiftStore.gift_status = data[6].status
    })
  }

  @action
  changeTabKey = async key => {
    this.key = key

    switch (+key) {
      case 1:
        this.getGift(key)
        break
      case 5:
      case 6:
        this.getCurrentList(key)
        break
      case 32:
        consultStore.getGift(key)
        break
    }
  }

  @observable list = []
  @observable reason
  @action
  getCurrentList = async id => {
    let {
      data: { option_list, reason }
    } = await Api.current_list({ id })
    runInAction(() => {
      this.list = option_list
      this.reason = reason
    })
  }

  @observable gift_content
  @observable gift_reason
  @action
  getGift = async id => {
    let {
      data: { content, reason }
    } = await Api.current_list({ id })
    runInAction(() => {
      this.gift_content = content
      this.gift_reason = reason
    })
  }

  @observable
  giftModal = {
    type: 2,
    isShow: false,
    content: '',
    btn1: '',
    btn2: '',
    hrefVal: ''
  }

  @observable
  promiseModal = {
    type: 2,
    isShow: false,
    content: '',
    btn1: '',
    btn2: '',
    hrefVal: ''
  }

  @action
  openTools = value => () => {
    const disable = !isUltimate() && !isProfessional()
    const title = getProTitle()
    if (value == 1) {
      if (disable) {
        this.giftModal = {
          type: 2,
          isShow: true,
          content: `无法使用此功能，请升级至${title}！`,
          btn1: '关闭',
          btn2: '了解详情',
          hrefVal: SHOP_PRODUCTS_PATH_A
        }
      } else {
        window.location.href = '#/localMerchant/marketingTools/setGift'
      }
      //window.location.href='#/localMerchant/marketingTools/setGift'
    } else if (value == 5 || value == 6) {
      if (disable) {
        this.giftModal = {
          type: 2,
          isShow: true,
          content: `无法使用此功能，请升级至${title}！`,
          btn1: '关闭',
          btn2: '了解详情',
          hrefVal: SHOP_PRODUCTS_PATH_A
        }
      } else if (mainStore.merchantInfo.bond_sign == 0) {
        this.promiseModal = {
          type: 2,
          isShow: true,
          content:
            '您尚未开通放心购·保证金功能或余额不足，暂时无法使用此功能！',
          btn1: '关闭',
          btn2: '了解放心购·保证金',
          hrefVal: BOND_PATH_A
        }
      } else {
        if (value == 5) {
          window.location.href = '#/localMerchant/marketingTools/setPromise'
        } else if (value == 6) {
          window.location.href = '#/localMerchant/marketingTools/setBack'
        }
      }
    }
  }

  @action
  onCancelGift = () => {
    this.giftModal.isShow = false
  }

  @action
  onCancelPromise = () => {
    this.promiseModal.isShow = false
  }
}
export default new Store()
